import { Button, styled } from '@mui/material';

const CustomButton = styled(Button)(({ theme }) => ({
  minWidth: 0,
  padding: theme.spacing(0.5),
  margin: `0 ${theme.spacing(0.5)}`,
}));

export default CustomButton;
